import _ from "lodash";
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import QueryString from "query-string";
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";

import ChangePasswordForm from "./ChangePasswordForm";
import { changePassword } from "../../modules";
import { AppStateDisplay, setAppError, clearAll } from "../../../common";
import strings from "../../../../res/strings";

import styled from "styled-components";

const Panel = styled.div`
  background: rgba(255, 255, 255, 0.15);
  height: 100vh;
`;

let ChangePasswordPanel = (props) => {
  const token = _.get(props.parsedQuery, "token");
  const uid = _.get(props.parsedQuery, "uid");

  const submitChangePassword = (values) => {
    if (values.newPassword !== values.confirmNewPassword) {
      props.setAppError({
        notificationType: "alert",
        context: "lib_authentication._.ChangePassword",
        message:
          strings.lib_authentication_state_error_password_confirm_password_new,
      });
    } else {
      values.token = token;
      values.uid = uid;
      props.changePassword({
        values,
        successState: {
          notificationType: "banner",
          title: strings.lib_authentication_state_success_change_password,
          message:
            strings.lib_authentication_state_success_change_password_details,
          redirects: [
            {
              label: strings.lib_authentication_redirect_login_proceed,
              onClick: () => {
                props.clearAll();
                props.setRightPanel("LOGIN");
              },
            },
          ],
        },
        errorState: {
          notificationType: "alert",
          context: "lib_authentication.changePassword.changePassword",
          message: strings.lib_common_state_error,
        },
      });
    }
  };

  return (
    <Panel>
      <AppStateDisplay parsedQuery={props.parsedQuery}>
        {!props.success && (
          <div>
            <ChangePasswordForm
              oldPasswordVisible={!(token && uid)}
              onSubmit={submitChangePassword}
              setRightPanel={props.setRightPanel}
            />
          </div>
        )}
      </AppStateDisplay>
    </Panel>
  );
};

const mapStateToPropsPanel = (state) => ({
  success: state.lib_application.success,
  error: state.lib_application.error,
});

const mapDispatchToPropsPanel = (dispatch) =>
  bindActionCreators(
    {
      changePassword,
      setAppError,
      clearAll,
    },
    dispatch
  );

ChangePasswordPanel = connect(
  mapStateToPropsPanel,
  mapDispatchToPropsPanel
)(ChangePasswordPanel);
export { ChangePasswordPanel };

/**
 * This component will be used for both change password in profile and reset password.
 * It just hides and shows some fields.
 *
 * ResetPasswordConfirm will be /reset-password/confirm route
 * ChangePassword will be /account/change-password authenticated-route
 *
 * Both Route and AuthenticatedRoute will be using this component.
 */
const ChangePassword = (props) => {
  const parsedQuery = QueryString.parse(props.location.search);
  const token = parsedQuery.token;
  const uid = parsedQuery.uid;

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>
            {token && uid
              ? strings.lib_authentication_title_reset_password_confirm
              : strings.lib_authentication_title_change_password}
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <ChangePasswordPanel parsedQuery={parsedQuery} />
        {/* <AppStateDisplay parsedQuery={parsedQuery}>
          {!props.success && (
            <div>
              <IonText color="primary">
                <PasswordInstructions>
                  {token && uid
                    ? strings.lib_authentication_instruction_reset_password_confirm
                    : strings.lib_authentication_instruction_change_password}
                </PasswordInstructions>
              </IonText>
              <ChangePasswordForm
                oldPasswordVisible={!(token && uid)}
                onSubmit={submitChangePassword}
              />
            </div>
          )}
        </AppStateDisplay> */}
      </IonContent>
    </IonPage>
  );
};

const mapStateToProps = (state) => ({
  success: state.lib_application.success,
  error: state.lib_application.error,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changePassword,
      setAppError,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
